
import React from 'react';
import { X, Lightbulb, Flame, Droplet } from 'lucide-react';
import MobileMenuProfile from './mobile/MobileMenuProfile';
import MobileMenuNavLinks from './mobile/MobileMenuNavLinks';
import MobileMenuSection from './mobile/MobileMenuSection';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  if (!isOpen) return null;

  return (
    <div className="md:hidden fixed inset-0 z-50 bg-black/20 backdrop-blur-sm overflow-hidden">
      <div className="absolute right-0 top-0 h-full w-3/4 max-w-xs bg-white dark:bg-gray-900 shadow-xl overflow-auto transform transition-transform duration-200 ease-in-out">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h3 className="font-semibold">Menu</h3>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800">
            <X className="h-5 w-5" />
          </button>
        </div>
        
        {/* User profile section */}
        <MobileMenuProfile onClose={onClose} />
        
        {/* Navigation links */}
        <MobileMenuNavLinks onClose={onClose} />
        
        {/* Utility sections */}
        <MobileMenuSection 
          icon={<Lightbulb />}
          label="Energy"
          color="text-energy-blue"
          onClose={onClose}
        />
        
        <MobileMenuSection 
          icon={<Flame />}
          label="Gas"
          color="text-amber-600"
          onClose={onClose}
        />
        
        <MobileMenuSection 
          icon={<Droplet />}
          label="Water"
          color="text-cyan-600"
          onClose={onClose}
        />
      </div>
      
      {/* Close the menu when clicking outside */}
      <div className="absolute inset-0" onClick={onClose}></div>
    </div>
  );
};

export default MobileMenu;
